<template>
  <div>
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        Have an account?
      </span>
      <router-link
        :to="{ name: 'login' }"
        class="font-weight-bold font-size-3 ml-2"
      >
        Login!
      </router-link>
    </div>
    <div class="login-form login-signin">
      <div class="text-center mb-5 mb-lg-10">
        <h3 class="font-size-h1">Confirm Account</h3>
        <p class="text-muted font-weight-semi-bold">
          Enter the code sent to your email.
        </p>
      </div>
      <b-form @submit.stop.prevent="onSubmit" class="form">
        <div
          class="alert fade alert-danger"
          role="alert"
          v-bind:class="{ show: error }"
        >
          <div class="alert-text">
            {{ error }}
          </div>
        </div>
        <b-form-group label="Code" label-for="code">
          <b-input-group>
            <b-form-input
                v-model="$v.form.code.$model"
                :state="validateState('code')"
                class="form-control form-control-solid h-auto py-3 px-3"
                name="code"
                placeholder="Code"
                size="sm"
                :type="(toggle.code)? 'text' : 'password'"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="toggle.code = !toggle.code">
                <b-icon :icon="(toggle.code)? 'eye' : 'eye-slash'"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback>
              Please enter Code.
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <button
            :disabled="this.isBusy || $v.$invalid"
            class="btn btn-block btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
            ref="kt_login_signin_submit"
          >
            Submit
          </button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGOUT, REGISTERMESSAGE } from "@/core/services/store/auth.module";
import { validationMixin } from "vuelidate";
import {
  required
} from "vuelidate/lib/validators";
import ApiService from "@/view/pages/easyreceipt/api";

export default {
  mixins: [validationMixin],
  name: "forgotpassword",
  data() {
    return {
      isBusy: false,
      form: {
        username: "",
        code: ""
      },
      toggle : {
        code : false
      }
    };
  },
  validations: {
    form: {
      code: { required }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      let self = this;
      self.isBusy = true;
      self.$v.form.$touch();
      if (self.$v.form.$anyError) {
        return;
      }
      const UserName = self.form.username;
      const Code = self.$v.form.code.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      const submitButton = self.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      let param = {UserName, Code};
      ApiService.post("business/ServerlessConfirmAccount", param)
                .then(({ data }) => {
                  self.$gtag.event("confirmaccount", param);
                  if (data) {
                    self.isBusy = false;
                    submitButton.classList.remove("spinner", "spinner-light","spinner-right");
                    this.$store
                        .dispatch(
                            REGISTERMESSAGE,
                            "Your account has been confirmed."
                        )
                        .then(() => self.$router.push({ name: "login" }));
                  }
                })
                .catch(() => {
                  self.isBusy = false;
                  submitButton.classList.remove("spinner", "spinner-light","spinner-right");
                });
    }
  },
  mounted() {
    let username = this.$route.query.username;
    if (username) {
      this.form.username = username;
    } else {
      this.$store
          .dispatch(REGISTERMESSAGE,"Invalid Action")
          .then(() => this.$router.push({ name: "login" }));
    }
  },
  computed: {
    ...mapState({
      error: state => state.auth.errors,
      registermessage: state => state.auth.registermessage
    })
  },
  watch: {
    error() {
      this.isBusy = false;
    }
  }
};
</script>
